import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CadastroFim } from '@/features/login/page/CadastroFim';

export const Route = createFileRoute('/auth/cadastro-fim')({
    component: CadastroFim,
    validateSearch: z.object({ encode: z.string().optional() }),
});
